module.exports = __webpack_public_path__ + "media/assets/img/products/studio_europe-not-selected-bb5136dab8ec0767a3a3a724214101c7.svg";